module.exports = __webpack_public_path__ + "media/images/emblems/Berolle-coat_of_arms-c5042e40c1acb7487ab00edabe9d5146.svg";